export const PARTNER_API_DOCS_CREATE_LEAD_REQUEST_PARAMETERS = [
    {
        name: 'partner_id',
        description: 'partner.api_docs.partner_id_description',
        type: 'partner.api_docs.integer',
        required: true,
    },
    {
        name: 'api_key',
        description: 'partner.api_docs.api_key_description',
        type: 'partner.api_docs.string',
        required: true,
    },
    {
        name: 'email',
        description: 'partner.api_docs.email_param_description',
        type: 'partner.api_docs.string',
        required: true,
    },
    {
        name: 'phone',
        description: 'partner.api_docs.phone_param_description',
        type: 'partner.api_docs.string',
        required: false,
    },
    {
        name: 'country',
        description: 'partner.api_docs.country_param_description',
        type: 'partner.api_docs.string',
        required: true,
    },
];

export const PARTNER_API_DOCS_CREATE_LEAD_RESPONSE_PARAMETERS = [
    {
        name: 'date_registered',
        description: 'partner.api_docs.date_registered_description',
        type: 'partner.api_docs.string',
    },
    {
        name: 'redirect_url',
        description: 'partner.api_docs.redirect_url_description',
        type: 'partner.api_docs.string',
    },
    {
        name: 'uid',
        description: 'partner.api_docs.uid_identifier',
        type: 'partner.api_docs.integer',
    },
];

export const PARTNER_API_DOCS_CREATE_LEAD_SAMPLE_REQUEST = `curl --location --request POST 'https://fx.binomo.com/api/v1/public/partner/lead/create' \\
--header 'Content-Type: application/json' \\
--data-raw '{
    "api_key": "12cdd271d769de456812eda59e4063b25b7fcd7fdf357a21637eshe4b2d4054c",
    "partner_id": 166,
    "email": "testutest023@example.com",
    "country": "br",
    "phone": "99999999999"
}'
`
export const PARTNER_API_DOCS_CREATE_LEAD_SAMPLE_RESPONSE = `{
    "date_registered": "2022-09-05T11:30:25.106Z",
    "redirect_url": "https://fx.binomo.com/confirm?a=166&email=testutest023%40example.com&code=1234567&accept-policy=1&phone=99999999999&country=br",
    "uid": 5
}    
`;